
import { OurTalentLogo1, OurTalentLogo2, OurTalentLogo3, OurTalentLogo4, OurTalentLogo5, OurTalentLogo6 } from '../../constants/ImagePaths'
import Image from '../../components/general/Image'

const PreviouslyRockedAt = () => {
    return (
        <div className="text-white bg-black">
            <div className="!pb-[60px] !pt-[20px] --layout-padding max-width lg:flex lg:justify-between lg:items-center">
                <div className="title-text text-[20px] lg:text-[18px] font-semibold text-left lg:mr-[30px]">
                    <span className='text-primary-color font-bold'>Our Talent</span> Previously
                    Rocked At
                </div>
                <div className="grid grid-cols-2 md:grid-cols-4 gap-[20px] mt-[30px] lg:mt-0 lg:grid-cols-6 lg:border-l lg:border-gray-500 lg:items-center lg:gap-[30px] lg:pl-[30px]">
                    <Image src={OurTalentLogo1} alt="our-talent-logo-1" className='w-[80%] lg:w-[100%]' />
                    <Image src={OurTalentLogo2} alt="our-talent-logo-2" className='w-[80%] lg:w-[100%]' />
                    <Image src={OurTalentLogo3} alt="our-talent-logo-3" className='w-[80%] lg:w-[100%]' />
                    <Image src={OurTalentLogo4} alt="our-talent-logo-4" className='w-[80%] lg:w-[100%]' />
                    <Image src={OurTalentLogo5} alt="our-talent-logo-5" className='w-[80%] lg:w-[100%]' />
                    <Image src={OurTalentLogo6} alt="our-talent-logo-6" className='w-[80%] lg:w-[100%]' />
                </div>
            </div>
        </div>
    )
}

export default PreviouslyRockedAt